import {
  Box,
  Center,
  Divider,
  Flex,
  ListItem,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
  Text,
  UnorderedList,
} from "@chakra-ui/react";
import { useRef, useState } from "react";
import { useForm } from "react-hook-form";
import LoadingSpinner from "../../LoadingSpinner";
import apiClient from "../../utils/ApiClient/apiClientAxios";
import CaseSearchResultTable from "../Case-Search/CaseSearchResultTable";
import CaseSearchForm from "./CaseSearchForm";
// import { demoCaseSearch } from "../../utils/demoData";

// eslint-disable-next-line react/prop-types
function SearchCaseModal({ isOpen, onClose, setClickCaseId }) {
  const [searchResult, setSearchResult] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const { register, handleSubmit, reset, setValue, watch } = useForm();
  const previousDataRef = useRef(null);

  const onSubmit = async (data) => {
    // Optional: skip if data hasn’t changed
    if (JSON.stringify(data) === JSON.stringify(previousDataRef.current)) {
      console.log("Data has not changed. Skipping API call.");
      return;
    }

    try {
      setIsLoading(true);
      const response = await apiClient.post("/searchCase", data);
      const result = response.data;
      setSearchResult(result);
      // Update previous data after successful API call
      previousDataRef.current = data;
      reset();
    } catch (err) {
      console.error("API error:", err);
    } finally {
      setIsLoading(false);
    }
  };

  const handleOpenCase = (clickedId, source) => {
    setClickCaseId({
      id: clickedId,
      source: source,
    });
    onClose();
  };

  return (
    <Box>
      <Modal
        isOpen={isOpen}
        onClose={onClose}
        size="6xl"
        isCentered
        // height="560px"
        closeOnOverlayClick={false}
        closeOnEsc={false}
      >
        <ModalOverlay />
        <ModalContent>
          <ModalCloseButton pl={5} color="bgColor" />
          <ModalBody
            style={{
              minHeight: "80vh",
              maxHeight: "80vh",
              overflowY: "auto",
            }}
          >
            <Flex gap={3} flexDir={{ base: "column", md: "row" }}>
              <Box w={{ base: "100%", md: "25%" }} h="100%">
                <CaseSearchForm
                  handleSubmit={handleSubmit}
                  onSubmit={onSubmit}
                  register={register}
                  isLoading={isLoading}
                  setValue={setValue}
                  watch={watch}
                />
                <UnorderedList my={2}>
                  <ListItem>
                    Search results may be filtered due to query size. Please
                    narrow criteria or use the Case Dashboard for efficient
                    browsing
                  </ListItem>
                </UnorderedList>
              </Box>
              <Box>
                <Center h="100%">
                  <Divider orientation="vertical" />
                </Center>
              </Box>
              <Box w={{ base: "100%", md: "75%" }}>
                {isLoading && <LoadingSpinner />}
                {!isLoading && !searchResult?.length > 0 && (
                  <Text textAlign="center" my={5}>
                    0 record returned.
                  </Text>
                )}

                {searchResult?.length > 0 && !isLoading && (
                  <CaseSearchResultTable
                    handleOpenCase={handleOpenCase}
                    searchResult={searchResult}
                    isLoading={isLoading}
                  />
                )}
              </Box>
            </Flex>
          </ModalBody>
        </ModalContent>
      </Modal>
    </Box>
  );
}

export default SearchCaseModal;
